import OnboardingApi from '../api/onboarding';

export default {
  namespaced: true,
  state: {
    status: null,
  },
  getters: {
    onboardingStatus(state) {
      return state.status;
    },
  },
  actions: {
    async getOnboardingStatus(context) {
      try {
        const status = await OnboardingApi.getOnboardingStatus();
        context.commit('SET_ONBOARDING_STATUS', status);
      } catch (error) {
        console.error('Error fetching onboarding status:', error);
        context.commit('SET_ONBOARDING_STATUS', {
          videoCount: 0,
          videoAnalysisChecked: false,
        });
      }
    },
  },
  mutations: {
    SET_ONBOARDING_STATUS: (state, status) => {
      state.status = status;
    },
  },
};
